import React, { useRef, useState } from "react";
import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "./MedicalCasesListing.css";
import { Dropdown } from "primereact/dropdown";
import {
  //currencyFormat,
  formatCi,
  formatFullNumber,
  // readableSex,
} from "../utils";
import { Link, useNavigate } from "react-router-dom";
import StatusTag from "../components/StatusTag";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Paginator } from "primereact/paginator";
import { iniciarTour, stopTour } from "../services/demoDriver";
import { CaseStatus, UserRole } from "../constants";
import Dashboard from "../Layout/Dashboard";

import { Checkbox } from "primereact/checkbox";
// Ejemplo si es de PrimeReact
import { InputText } from 'primereact/inputtext';


import {
  useMedicalCases,
  //useRequirementTypes,
  useMedicalCasesCount,
  useClients,
  useGetInsurance,
  useStaleMedicalCases,
} from "../hooks/queries";
import {
  ChangeStatusMultipleModal,
  ChangeStatusSingleModal,
} from "../components/StatusChangeModal";
import { usePatchMedicalCase } from "../hooks/mutations";
// import { StatusSelector } from "../components/StatusChangeSelector";
import { useMutation } from "@tanstack/react-query";
import { updateMultipleCasesStatus } from "../services/medicalCases";
import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import { PaginatorTemplate } from "../Layout/Paginator/PaginatorTemplate";
import { Card } from "primereact/card";
import ExportCasesDialog from "./Modals/ExportCasesDialog";
import { useEffect } from "react";
import CasesPendingDialog from "./Modals/CasesPendigDialog";
// import ListingDataView from "./Listing/ListingDataView";

// import { useGetInsurance } from "../hooks/queries";

/**
 * Dropdown to filter case patient sex
 */
// const sexFilterTemplate = (options) => (
//   <Dropdown
//     value={options.value}
//     options={GENDERS}
//     onChange={(e) => options.filterApplyCallback(e.value)}
//     placeholder="Seleccionar sexo"
//     className="p-column-filter min-w-min"
//     showClear
//     style={{ maxWidth: "10rem" }}
//   />
// );

/**
 * Template to show the amount in currency format
 */
//const amountBodyTemplate = (rowData) => {
  //return currencyFormat(rowData.amount ?? 0);
//};

/**
 * Status tag for filter selector
 * @param {string} option
 */
const statusItemTemplate = (option) => {
  return <StatusTag value={option?.value} />;
};

const caseStatusArray = Object.entries(CaseStatus.labels).map(
  ([key, item]) => ({
    label: item,
    value: key,
  })
);

/**
 * Status filter dropdown
 * @param {string[]} options
 */
const statusRowFilterTemplate = (options) => {
  return (
    <Dropdown
      value={options.value}
      options={caseStatusArray}
      onChange={(e) => {
        options.filterApplyCallback(e.value);
      }}
      itemTemplate={statusItemTemplate}
      placeholder="Seleccionar status"
      className="p-column-filter min-w-min"
      showClear
    />
  );
};

/**
 * Medical cases table
 */

export default function MedicalCasesListing() {


const [isDemoMode, setIsDemoMode] = useState(localStorage.getItem('demoMode') === 'true');
const [demoFilter, setDemoFilter] = useState("");

/////////////////////////////////
const [isTourRunning, setIsTourRunning] = useState(false);
console.log("isTourRunning", isTourRunning);
console.log("isDemoMode", isDemoMode);
console.log("demoFilter", demoFilter);
console.log("demoFilter", demoFilter,setDemoFilter);
// En MedicalCasesListing.js
const DemoFilter = ({ isDemoMode, onFilterChange }) => {
  if (!isDemoMode) return null;

  return (
    <div className="p-inputgroup">
      <InputText
        placeholder="Filtrar casos demo (ej: DEMO001)"
        onChange={(e) => onFilterChange(e.target.value)}
      />
      <Button 
        icon="pi pi-info-circle" 
        tooltip="Estás filtrando datos de demostración"
        tooltipOptions={{ position: 'top' }}
      />
    </div>
  );
};
console.log("isDemoMode", DemoFilter);



  const role = localStorage.getItem("role");

  const [pageSize, setPageSize] = useState(20);
  const [lazyFilters, setLazyFilters] = useState({
    status: null,
  });
  // const [lazyExportFilters, setLazyExportFilters] = useState({
  //   status: null,
  // });
  const [lazyState, setLazyState] = useState({
    first: 1,
    rows: 10,
    page: 1,
    sortField: null,
    sortOrder: null,
    filters: {},
  });

  // Get medical cases
  const casesQuery = useMedicalCases({
    page: lazyState.page,
    pageSize,
    filters: lazyFilters,
  });

  const casesCountQuery = useMedicalCasesCount();
  const [statusFilter, setStatusFilter] = useState(null);
  const staleCases = useStaleMedicalCases({ page: 1, filters: {} });



  const navigate = useNavigate();

  // useEffect de restauración de filtros y estado
   useEffect(() => {
      const savedFilters = sessionStorage.getItem("medicalCasesReturnFilters");
      const savedLazyState = sessionStorage.getItem("medicalCasesReturnLazyState");
      if (savedFilters) {
        const filtersToRestore = JSON.parse(savedFilters);

        // Restaurar filtros de negocio
        setLazyFilters({
          ...filtersToRestore.lazyFilters,
          service_id__isnull: filtersToRestore.lazyFilters.service_id__isnull
        });
        setStatusFilter(filtersToRestore.statusFilter);
        setDateFilter(
          filtersToRestore.dateFilter ? new Date(filtersToRestore.dateFilter) : null
        );

        // Restaurar selectedClient
        const clientValue = filtersToRestore.lazyFilters.company_client;
        setSelectedClient(clientValue);

        // Restaurar otros filtros visuales (menos company_client)
        setFilters(prev => ({
          ...prev,
          service_id: { 
            value: filtersToRestore.lazyFilters["service_id__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          id: { 
            value: filtersToRestore.lazyFilters["parent_case__id__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          "holder_.ci": { 
            value: filtersToRestore.lazyFilters["holder__ci__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          "patient_.ci": { 
            value: filtersToRestore.lazyFilters["patient__ci__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          "patient_.name": { 
            value: filtersToRestore.lazyFilters["patient__name__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          medical_center_name: { 
            value: filtersToRestore.lazyFilters["medical_center__name__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          state_name: { 
            value: filtersToRestore.lazyFilters["state__name__icontains"] || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
          status: { 
            value: filtersToRestore.statusFilter || null, 
            matchMode: FilterMatchMode.CONTAINS 
          },
        }));

        sessionStorage.removeItem("medicalCasesReturnFilters");
      }

      if (savedLazyState) {
            const lazyStateToRestore = JSON.parse(savedLazyState);
            setLazyState(lazyStateToRestore);
            sessionStorage.removeItem("medicalCasesReturnLazyState");
          }
    }, []);

  //ViewDetailBodyTemplate para ir a detalle del caso
  // y filtros en sessionStorage antes de navegar a los detalles del caso
  const ViewDetailBodyTemplate = (row) => {
    const handleClick = () => {
      sessionStorage.setItem("medicalCasesReturnPage", String(lazyState.page));
      sessionStorage.setItem(
        "medicalCasesReturnFilters",
        JSON.stringify({
          lazyFilters,
          statusFilter,
          dateFilter: dateFilter ? dateFilter.toISOString() : null,
          // Añade selectedClient para restaurarlo
          selectedClient, 
        })
      );
      sessionStorage.setItem(
        "medicalCasesReturnLazyState",
        JSON.stringify({
          lazyFilters: {
            ...lazyFilters,
            service_id__isnull: lazyFilters.service_id__isnull
          },
          // ... resto de los datos guardados
        })
      );
    };
    return (
      <Link id="details-buttong" to={String(row.id)} onClick={handleClick} className="p-button text-sm p-2">
        <span className="p-button-icon p-button-icon-left pi pi-eye"></span>
        <span className="p-button-label">Ver</span>
      </Link>
    );
  };

 
  



  // Status change
  const [rowChanging, setRowChanging] = useState(null);
  const [newStatus, setNewStatus] = useState(null);
  const [newStatusMultiple, setNewStatusMultiple] = useState(null);
  const [showMultipleModal, setShowMultipleModal] = useState(false);
  const [dateFilter, setDateFilter] = useState(null);

  const toastRef = useRef(null);

  // Table multiple selection
  const [selectedRows, setSelectedRows] = useState(null);

  // Get requirement types
  //const requirementTypesQuery = useRequirementTypes();

  const clientsQuery = useClients(false);

  const useInsurance = useGetInsurance();
  const insurance = useInsurance?.data;

  const [showPendingDialog, setShowPendingDialog] = useState(null);
  

  // Update medical case from listing
  const caseMutation = usePatchMedicalCase({
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        casesQuery.refetch();
        setRowChanging(null);
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
        setRowChanging(null);
      }
    },
  });

  // Update multiple cases status
  const caseMultipleMutation = useMutation({
    mutationFn: updateMultipleCasesStatus,
    onSuccess: ({ type, message }) => {
      if (type === "success") {
        toastRef.current.show({
          severity: "success",
          summary: "Éxito",
          detail: message,
        });
        casesQuery.refetch();
        setShowMultipleModal(false);
        setSelectedRows([]);
        setNewStatusMultiple(null);
      } else {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: message,
        });
        setShowMultipleModal(false);
      }
    },
  });

  // Global filters
  const [filters, setFilters] = useState({
    // global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    service_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    company_client: { value: null, matchMode: FilterMatchMode.CONTAINS },
    created: { value: null, matchMode: FilterMatchMode.CONTAINS },
    id: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.sex": { value: null, matchMode: FilterMatchMode.EQUALS },
    requirement_type_names: { value: null, matchMode: FilterMatchMode.EQUALS },
    "holder_.ci": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.ci": { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.name": { value: null, matchMode: FilterMatchMode.CONTAINS },
    requirement_names: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.birthdate": { value: null, matchMode: FilterMatchMode.CONTAINS },
    diagnosis_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    medical_center_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    subsidiary_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    "patient_.phone": { value: null, matchMode: FilterMatchMode.CONTAINS },
    state_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });
  // const [globalFilterValue, setGlobalFilterValue] = useState("");

  // const onGlobalFilterChange = (e) => {
  //   const value = e.target.value;
  //   let _filters = { ...filters };

  //   _filters["global"].value = value;

  //   setFilters(_filters);
  //   setGlobalFilterValue(value);
  // };

  /**
   * Status tag for table body
   */
  const statusBodyTemplate = (rowData) => (
    <>
      <StatusTag value={rowData.status} />
      {rowData.prioritized &&
        (rowData.status === CaseStatus.PENDIENTE ||
          rowData.status === CaseStatus.RESCHEDULED) && (
          <StatusTag className="mt-2" value={CaseStatus.PRIORITIZED} />
        )}
    </>
    // <StatusSelector
    //   currentStatus={rowData.status}
    //   selectedStatus={rowData.status}
    //   onChange={(e) => {
    //     setNewStatus(e.value);
    //     setRowChanging(rowData);
    //   }}
    // />
  );

  const [selectedClient, setSelectedClient] = useState(null);

  /*const clientRowFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={clientsQuery.data ?? []}
        optionLabel="name"
        optionValue="id"
        onChange={(e) => {
          options.filterApplyCallback(e.value);
        }}
        // itemTemplate={statusItemTemplate}
        placeholder="Seleccionar cliente"
        className="p-column-filter min-w-min"
        showClear
      />
    );
  };*/

  
 const clientRowFilterTemplate = () => {
  return (
    <Dropdown
      value={selectedClient}
      options={clientsQuery.data ?? []}
      optionLabel="name"
      optionValue="id"
      onChange={(e) => {
        setSelectedClient(e.value);
        
        setLazyFilters(prev => ({
          ...prev,
          company_client: e.value,
          subsidiary__company_client: e.value,
        }));
        
        setLazyState(prev => ({ ...prev, first: 0, page: 1 }));
      }}
      placeholder="Seleccionar cliente"
      className="p-column-filter min-w-min"
      showClear
      filter
    />
  );
};

  /**
   * Dropdown to filter case requirement type
   
 const requirementTypeFilterTemplate = (options) => (

    
    <Dropdown
      value={options.value}
      
      loading={requirementTypesQuery.isLoading}
      disabled={requirementTypesQuery.isLoading}
      options={requirementTypesQuery.data ?? []}
      
      optionValue="id"
      optionLabel="name"
      
      onChange={(e) => {
        
        return options.filterApplyCallback(e.value);
      }}
      placeholder="Seleccionar tipo"
      className="p-column-filter min-w-min"
      showClear
      filter
      style={{ maxWidth: "10rem" }}
    />
    
  );
  */

  /**
   * Page event
   *
   */
  const onPageChange = (e) => {
    setPageSize(e.rows);
    setLazyState({ ...lazyState, first: e.first, page: e.page + 1 });
  };

  const onFilter = (event) => {
    setFilters(event.filters);
    event["first"] = 0;
    setLazyState(event);
    // const dateFormat = event.filters.created.value.toISOString().split('T')[0];
    // console.log("dateformat", dateFormat)
    let status = event.filters.status.value;
    let prioritized = null;
    if (status === CaseStatus.PRIORITIZED) {
      status = null;
      prioritized = true;
    }

    setLazyFilters({
      ...lazyFilters,
      subsidiary__company_client: event.filters.company_client.value,
      company_client: event.filters.company_client.value,
      status: status,
      prioritized: prioritized,
      id_parent: event.filters.id.value,
      // id__contains: event.filters.id.value,
      holder__ci__icontains: event.filters["holder_.ci"].value,
      patient__ci__icontains: event.filters["patient_.ci"].value,
      patient__name__icontains: event.filters["patient_.name"].value,
      medical_center__name__icontains: event.filters.medical_center_name.value,
      requirements__requirement__type_requirement:
        event.filters.requirement_type_names.value,
      state__name__icontains: event.filters.state_name.value,
      service_id__icontains: event.filters.service_id.value,
      parent_case__id__icontains: event.filters.id.value,

      service_id__isnull: lazyFilters.service_id__isnull
    });
  };
  const [showExportDialog, setShowExportDialog] = useState(false);

  // if (staleCases.data?.count > 0 && role !== UserRole.SUB_ADMINISTRATOR) {
  //   console.log("casos pendientes", staleCases.data?.count);
  //   navigate("/casos-pendientes");
  // }

  useEffect(() => {
    if (staleCases.data?.count > 0 && role !== UserRole.SUB_ADMINISTRATOR) {
      const currentTime = Date.now();
      const storedTime =
        localStorage.getItem("lastNavigationTime") ||
        currentTime - 30 * 60 * 1000;
      // 30 * 60 *
      if(!storedTime) {
        localStorage.setItem("lastNavigationTime", currentTime);
        setShowPendingDialog(true);
      }

      if (storedTime && currentTime - storedTime >= 60 * 1000) {
        localStorage.setItem("lastNavigationTime", currentTime);
        // navigate("/casos-pendientes");
        setShowPendingDialog(true);
      }
    }
  }, [staleCases.data?.count, role, navigate]);




  const handleExportClick = () => {
    setShowExportDialog(true);
  };

  const handleExportDialogHide = () => {
    setShowExportDialog(false);
  };

  // useEffect(() => {
  //   if (storedDate) {
  //     const currentDate = new Date();
  //     if(staleCases.data?.count > 0 ) {

  //       if(storedDate === null) {
  //         setShowPendingDialog(true);
  //         // localStorage.setItem("hideModalUntil",currentDate);
  //       }
  
  //       if (currentDate - storedDate >= 60* 1000) {
  //         setShowPendingDialog(true);
  //         localStorage.setItem("lastNavigationTime",currentDate);
  //       } 
  //     }
  //   }
  // }, [storedDate]);

  /**
   * Cases table header
   */
  const TableHeader = ({ newStatus, changeNewStatus, onStatusChangeClick }) => {
    return (
      <div className="full-w-header">
        <div className=" mb-2">
          <FloatLabel>
            <Calendar
              locale="es"
              inputId="created_date"
              value={dateFilter}
              onChange={(e) => {
                // options.filterCallback(e.value, options.index)
                // console.log("Value",e.value)
                console.log(e.originalEvent.type);
                if (
                  e.originalEvent.type === "click" ||
                  e.originalEvent.type === "keypress"
                ) {
                  console.log(e);
                  setDateFilter(e.value);

                  const dateFormat = e.value?.toISOString().split("T")[0];
                  console.log(dateFormat);
                  setLazyFilters({
                    ...lazyFilters,
                    created_at__date: dateFormat,
                  });
                }
                if (e.value === dateFilter) return;

                if (!e.value) {
                  setDateFilter(null);
                }
              }}
              dateFormat="mm/dd/yy"
              placeholder="dia/mes/año"
              mask="99/99/9999"
              showButtonBar
            />
            <label htmlFor="created_date">Buscar por fecha</label>
          </FloatLabel>
        </div>
        <div>
          <Button
            label="Exportar"
            icon="pi pi-file-pdf"
            severity="warning"
            className="p-button-success"
            onClick={handleExportClick}
            // loading={caseAllQuery.isLoading}
            // disabled={!caseAllQuery.data?.results.length}
          />
        </div>
        {/* <div>
          <Dropdown
            placeholder="Cambiar status en lote"
            options={getStatusChangeOptionsForRole()}
            itemTemplate={statusItemTemplate}
            valueTemplate={
              newStatus !== null && (
                <span>
                  Cambiar a: <StatusTag value={newStatus} />
                </span>
              )
            }
            value={newStatus}
            onChange={(e) => changeNewStatus(e.value)}
          />
          <Button
            label="Aplicar"
            className="ml-3"
            onClick={onStatusChangeClick}
          />
        </div> */}
        {/* <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Buscar palabra clave"
          />
        </IconField> */}
      </div>
    );
  };

  const changeStatusFilter = (status, prioritized=null) => {
    if (statusFilter === status) {
      setStatusFilter(null);
      setLazyFilters({
        ...lazyFilters,
        status: null,
        prioritized: null,
      });
      return;
    }
    setStatusFilter(status);
    setLazyFilters({
      ...lazyFilters,
      status,
      prioritized,
    });
  };

  console.log(staleCases)

  
  return (

    
    <Dashboard headerTitle="Casos">


      {role === UserRole.MEDICAL_CENTER && (
      <Button 
        id="boton-tourg" 
        className="mi-boton-demo"
        onClick={() => {
          setIsTourRunning(true);
          const newMode = !isDemoMode;
          setIsDemoMode(newMode);
          localStorage.setItem('demoMode', newMode.toString());
          if (newMode) {
            iniciarTour();
            toastRef.current.show({
              severity: 'info',
              summary: 'Modo Demo Activado',
              detail: 'Ahora estás en modo demostración',
              life: 1000
            });
          } else {
            stopTour();
            toastRef.current.show({
              severity: 'warn',
              summary: 'Modo Demo Desactivado',
              detail: 'Has salido del modo demo.',
              life: 1000
            });
          }
        }}
      >
        {isDemoMode ? "Desactivar Demo" : "Iniciar Tutorial/Demo"}
      </Button>
    )}
      <CasesPendingDialog
        visible={showPendingDialog}
        onClose={(value) => {
          setShowPendingDialog(value);
        }}
        staleCases={staleCases}

      />

      
      <div className="card">

        <Toast ref={toastRef} position="top-center" />
        <div className="flex flex-wrap gap-3 mb-2">
          <Card
            id="case-status-priorizado" //id nuevo
            title=""
            className={`w-3 my-2 card-count md:w-3 lg:w-2 ${
              statusFilter === CaseStatus.PRIORITIZED
                ? "is-active case-status-priorizado"
                : ""
            }`}
            onClick={() => changeStatusFilter(null, true)}
          >
            {statusFilter === CaseStatus.PRIORITIZED && (
              <Button
                icon="pi pi-times"
                className="p-button-danger p-button-shadown-none"
                style={{ position: "absolute", top: "0", right: "0" }}
                text
                size="small"
                tooltip="Limpiar filtro"
                onClick={() => changeStatusFilter(null)}
              />
            )}
            {casesCountQuery.data && (
              <div className="text-xl text-center">
                <p className="m-0">
                  <strong>{casesCountQuery.data?.prioritized_count}</strong>
                </p>
                <StatusTag value={CaseStatus.PRIORITIZED} />
              </div>
            )}
          </Card>
          <Card
            id="case-status-pendiente"
            title=""
            className={`w-3 my-2 card-count md:w-3 lg:w-2 ${
              statusFilter === CaseStatus.PENDIENTE
                ? "is-active case-status-pendiente"
                : ""
            }`}
            onClick={() => changeStatusFilter(CaseStatus.PENDIENTE)}
          >
            {
              statusFilter === CaseStatus.PENDIENTE && (

                <Button
                  icon="pi pi-times"
                  className="p-button-danger p-button-shadown-none"
                  style={{ position: "absolute", top: "0", right: "0" }}
                  text
                  size="small"
                  tooltip="Limpiar filtro"
                  onClick={() => changeStatusFilter(CaseStatus.PENDIENTE)}
                />
              )
            }
            {casesCountQuery.data && (
              <div className="text-xl text-center">
                <p className="m-0">
                  <strong>{casesCountQuery.data?.pending_count}</strong>
                </p>
                <StatusTag value={CaseStatus.PENDIENTE} />
              </div>
            )}
          </Card>
          <Card
            id="case-status-agendado"
            title=""
            className={`w-3 my-2 card-count md:w-3 lg:w-2 ${
              statusFilter === CaseStatus.RESCHEDULED
                ? "is-active case-status-agendado"
                : ""
            }`}
            onClick={() => changeStatusFilter(CaseStatus.RESCHEDULED)}
          >
            {statusFilter === CaseStatus.RESCHEDULED && (
              <Button
                icon="pi pi-times"
                className="p-button-danger p-button-shadown-none"
                style={{ position: "absolute", top: "0", right: "0" }}
                text
                size="small"
                tooltip="Limpiar filtro"
                onClick={() => changeStatusFilter(CaseStatus.RESCHEDULED)}
              />
            )}
            {casesCountQuery.data && (
              <div className="text-xl text-center">
                <p className="m-0">
                  <strong>{casesCountQuery.data?.scheduled_count}</strong>
                </p>
                <StatusTag value={CaseStatus.RESCHEDULED} />
              </div>
            )}
          </Card>
          <Card
            id="case-status-atendido"
            title=""
            className={`w-3 my-2 card-count md:w-3 lg:w-2 ${
              statusFilter === CaseStatus.ATENDIDO
                ? "is-active case-status-atendido"
                : ""
            }`}
            onClick={() => changeStatusFilter(CaseStatus.ATENDIDO)}
          >
            {statusFilter === CaseStatus.ATENDIDO && (
              <Button
                icon="pi pi-times"
                className="p-button-danger p-button-shadown-none"
                style={{ position: "absolute", top: "0", right: "0" }}
                text
                size="small"
                tooltip="Limpiar filtro"
                onClick={() => changeStatusFilter(CaseStatus.ATENDIDO)}
              />
            )}
            {casesCountQuery.data && (
              <div className=" text-center">
                <p className="text-xl m-0">
                  <strong>{casesCountQuery.data?.attended_count}</strong>
                </p>
                <StatusTag value={CaseStatus.ATENDIDO} />
              </div>
            )}
          </Card>
          <Card
            id="case-status-remesado"
            title=""
            className={`w-3 my-2 card-count md:w-3 lg:w-2 ${
              statusFilter === CaseStatus.REMESADO
                ? "is-active case-status-remesado"
                : ""
            }`}
            onClick={() => changeStatusFilter(CaseStatus.REMESADO)}
          >
            {statusFilter === CaseStatus.REMESADO && (
              <Button
                icon="pi pi-times"
                className="p-button-danger p-button-shadown-none"
                style={{ position: "absolute", top: "0", right: "0" }}
                text
                size="small"
                tooltip="Limpiar filtro"
                onClick={() => changeStatusFilter(CaseStatus.REMESADO)}
              />
            )}
            {casesCountQuery.data && (
              <div className=" text-center">
                <p className="text-xl m-0">
                  <strong>{casesCountQuery.data?.remitted_count}</strong>
                </p>
                <StatusTag value={CaseStatus.REMESADO} />
              </div>
            )}
          </Card>
        </div>
        {/* <ListingDataView data={casesQuery.data?.results ?? []}/> */}

        <DataTable
          value={casesQuery.data?.results ?? []}
          
          

          dataKey="id"
          size={"small"}
          filters={filters}
          loading={casesQuery.isLoading}
          onFilter={onFilter}
          header={
            <TableHeader
              newStatus={newStatusMultiple}
              changeNewStatus={setNewStatusMultiple}
              onStatusChangeClick={() => setShowMultipleModal(true)}
            />
          }
          emptyMessage="No se hallaron casos."
          selectionMode="checkbox"
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          stripedRows
          scrollable
          removableSort
          // rowClassName={(rowData) => ({
          //   "bg-green-300":
          //     rowData.prioritized &&
          //     [CaseStatus.PENDIENTE, CaseStatus.RESCHEDULED].includes(
          //       rowData.status
          //     ),
          // })}
        >
          {/* <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} /> */}
          <Column
            field="company_client"
            header="Cliente"
            filter
            filterPlaceholder="Buscar por Cliente"
            filterElement={clientRowFilterTemplate}
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            body={(row) => {
              if (role === UserRole.MEDICAL_CENTER) {
                return row.parent_medical_center_name ?? row.company_client;
              }
              return row.company_client;
            }}
          />
          <Column
            field="created"
            header="Fecha"
            // filter
            dataType="date"
            filterPlaceholder="Buscar por fecha"
            // showFilterMatchModes={false}
            // showClearButton={false}
            // showApplyButton={false}
            // filterElement={dateFilterTemplate}
          />

          <Column
            field="service_id"
            header="Nro. Siniestro"
            filter
            filterPlaceholder="Buscar Nro. de Siniestro"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            filterElement={(options) => (
              <div className="flex flex-column gap-2">
                <InputText
                  value={options.value || ''}
                  onChange={(e) => options.filterApplyCallback(e.target.value)}
                  placeholder="Buscar Nro. de Siniestro"
                />
                <div className="flex align-items-center">
                  <Checkbox 
                    inputId="filter-null-service"
                    checked={lazyFilters.service_id__isnull === true}
                    onChange={(e) => {
                      setLazyFilters(prev => ({
                        ...prev,
                        service_id__icontains: e.checked ? undefined : prev.service_id__icontains,
                        service_id__isnull: e.checked || undefined
                      }));
                      setLazyState(prev => ({ ...prev, first: 0, page: 1 }));
                    }}
                  />
                  <label htmlFor="filter-null-service" className="ml-2">
                    Mostrar solo casos sin siniestro
                  </label>
                </div>
              </div>
            )}
          />

          <Column
            field="id"
            header="ID #"
            sortable
            filter
            filterPlaceholder="Buscar por Nro. de Caso"
            body={(row) => {
              return row.parent_case_id ?? row.id;
            }}
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
          />

          <Column
            field="holder_.ci"
            header="CI Titular"
            filter
            filterPlaceholder="Buscar por Titular"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) => formatCi(row.holder_.ci)}
            
          />
          {/* <Column
            field="holder_ci"
            header="CI Titular"
            filter
            filterPlaceholder="Buscar por Titular"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) => formatCi(row.holder_ci)}
          /> */}

          <Column
            field="patient_.ci"
            header="CI Paciente"
            filter
            filterPlaceholder="Buscar por CI Paciente"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) => formatCi(row.patient_.ci)}
            
          />
          {/* <Column
            field="patient_ci"
            header="CI Paciente"
            filter
            filterPlaceholder="Buscar por CI Paciente"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) => formatCi(row.patient_ci)}
          /> */}
          <Column
            field="patient_.name"
            header="Nombre Paciente"
            filter
            filterPlaceholder="Buscar por Nombre"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
          />
          {/* <Column
            field="patient_name"
            header="Nombre Paciente"
            filter
            filterPlaceholder="Buscar por Nombre"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
          /> */}
       
          <Column
            field="patient_.phone"
            header="Teléfono Paciente"
            filter
            filterPlaceholder="Buscar por Teléfono"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) => formatFullNumber(row.patient_.phone)}
          />
          {/* <Column
            field="patient_phone"
            header="Teléfono Paciente"
            filter
            filterPlaceholder="Buscar por Teléfono"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) => formatFullNumber(row.patient_phone)}
          /> */}
          {insurance?.name === "Vértice Seguros" && (
            <Column
              field="state_name"
              header="Estado"
              filter
              filterPlaceholder="Buscar por Estado"
              showFilterMatchModes={false}
              showClearButton={false}
              showApplyButton={false}
              bodyClassName="readable-cell"
              sortable
            />
          )}
          {/* <Column
            field="patient_.birthdate"
            header="Fecha de Nacimiento"
            filter
            filterPlaceholder="Buscar por Fecha"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            body={(row) => formatDateString(row.patient_.birthdate)}
          /> */}
          {/* <Column
            field="patient_.sex"
            header="Sexo"
            filter
            filterElement={sexFilterTemplate}
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            body={(row) => readableSex(row.patient_.sex)}
          /> */}
          {/* <Column
            field="requirement_type_names"
            header="Tipo de requerimiento"
            filter
            filterElement={requirementTypeFilterTemplate}
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
          /> 
          <Column
            header="Tipo de requerimiento"
            body={(rowData) => rowData.type_requirement_name || "-"}
            filter
            filterField="id"  // ← Aquí va el campo real de tus datos
            filterElement={requirementTypeFilterTemplate}
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
          />
          */}
          
          <Column
            field="requirements_name"
            header="Requerimiento"
            filter
            filterPlaceholder="Buscar por Requerimiento"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
            body={(row) =>
              row.requirements_name.slice(0, 60) +
              (row.requirements_name.length > 60 ? "..." : "")
            }
          />
          {/* 
          <Column
            field="amount"
            header={
              insurance?.name === "Vértice Seguros"
                ? "Monto REF"
                : "Monto (Bs.)"
            }
            filter
            filterPlaceholder="Buscar por Monto"
            showFilterMenu={false}
            body={amountBodyTemplate}
            bodyClassName="readable-cell"
            sortable
          />
          <Column
            field="diagnosis_name"
            header="Diagnóstico"
            filter
            filterPlaceholder="Buscar por Diagnóstico"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
          />
          */}
          <Column
            field="medical_center_name"
            header="Proveedor"
            filter
            filterPlaceholder="Buscar por Proveedor"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            bodyClassName="readable-cell"
          />
          <Column
            field="status"
            header="Status"
            showFilterMatchModes={false}
            showClearButton={false}
            showApplyButton={false}
            body={statusBodyTemplate}
            filter
            filterElement={statusRowFilterTemplate}
            frozen
            alignFrozen="right"
          />
          <Column
            header="Acción"
            body={ViewDetailBodyTemplate}
            frozen
            alignFrozen="right"
          />
     
                 
        </DataTable>

 



        {/* <Paginator rows={15} /> */}
        <Paginator
          first={lazyState.first}
          rows={pageSize}
          totalRecords={casesQuery.data?.count}
          template={PaginatorTemplate}
          // rowsPerPageOptions={[10, 20, 30, 50,100]}
          onPageChange={onPageChange}
        />

        <ChangeStatusSingleModal
          rowChanging={rowChanging}
          newStatus={newStatus}
          show={rowChanging !== null}
          onHide={() => {
            if (rowChanging === null) return;
            setRowChanging(null);
            setNewStatus(null);
          }}
          onSave={() => {
            if (rowChanging === null || newStatus === null) return;
            caseMutation.mutate({
              caseId: rowChanging.id,
              data: { status: newStatus },
            });
          }}
        />
        <ChangeStatusMultipleModal
          show={showMultipleModal}
          selection={selectedRows}
          newStatus={newStatusMultiple}
          onHide={() => {
            if (!showMultipleModal) return;
            setShowMultipleModal(false);
          }}
          onSave={() => {
            if (!showMultipleModal || !newStatusMultiple) return;
            caseMultipleMutation.mutate({
              caseIds: selectedRows.map((row) => row.id),
              status: newStatusMultiple,
            });
          }}
          loading={caseMultipleMutation.isPending}
        />

        <ExportCasesDialog
          visible={showExportDialog}
          onHide={handleExportDialogHide}
        />
      </div>
    </Dashboard>
  );
}
